// countryCodes.js
export const COUNTRY_CODES = [
  { label: "Afghanistan", code: "+93", value: "AF", phoneLength: 9 },
  { label: "Albania", code: "+355", value: "AL", phoneLength: 9 },
  { label: "Algeria", code: "+213", value: "DZ", phoneLength: 9 },
  { label: "Andorra", code: "+376", value: "AD", phoneLength: 6 },
  { label: "Angola", code: "+244", value: "AO", phoneLength: 9 },
  { label: "Antigua and Barbuda", code: "+1-268", value: "AG", phoneLength: 7 },
  { label: "Argentina", code: "+54", value: "AR", phoneLength: 10 },
  { label: "Armenia", code: "+374", value: "AM", phoneLength: 8 },
  { label: "Australia", code: "+61", value: "AU", phoneLength: 9 },
  { label: "Austria", code: "+43", value: "AT", phoneLength: 10 },
  { label: "Azerbaijan", code: "+994", value: "AZ", phoneLength: 9 },

  { label: "Bahamas", code: "+1-242", value: "BS", phoneLength: 7 },
  { label: "Bahrain", code: "+973", value: "BH", phoneLength: 8 },
  { label: "Bangladesh", code: "+880", value: "BD", phoneLength: 10 },
  { label: "Barbados", code: "+1-246", value: "BB", phoneLength: 7 },
  { label: "Belarus", code: "+375", value: "BY", phoneLength: 9 },
  { label: "Belgium", code: "+32", value: "BE", phoneLength: 9 },
  { label: "Belize", code: "+501", value: "BZ", phoneLength: 7 },
  { label: "Benin", code: "+229", value: "BJ", phoneLength: 8 },
  { label: "Bhutan", code: "+975", value: "BT", phoneLength: 8 },
  { label: "Bolivia", code: "+591", value: "BO", phoneLength: 8 },
  { label: "Bosnia and Herzegovina", code: "+387", value: "BA", phoneLength: 8 },
  { label: "Botswana", code: "+267", value: "BW", phoneLength: 8 },
  { label: "Brazil", code: "+55", value: "BR", phoneLength: 11 },
  { label: "Brunei", code: "+673", value: "BN", phoneLength: 7 },
  { label: "Bulgaria", code: "+359", value: "BG", phoneLength: 9 },
  { label: "Burkina Faso", code: "+226", value: "BF", phoneLength: 8 },
  { label: "Burundi", code: "+257", value: "BI", phoneLength: 8 },

  { label: "Cambodia", code: "+855", value: "KH", phoneLength: 9 },
  { label: "Cameroon", code: "+237", value: "CM", phoneLength: 9 },
  { label: "Canada", code: "+1", value: "CA", phoneLength: 10 },
  { label: "Cape Verde", code: "+238", value: "CV", phoneLength: 7 },
  { label: "Central African Republic", code: "+236", value: "CF", phoneLength: 8 },
  { label: "Chad", code: "+235", value: "TD", phoneLength: 8 },
  { label: "Chile", code: "+56", value: "CL", phoneLength: 9 },
  { label: "China", code: "+86", value: "CN", phoneLength: 11 },
  { label: "Colombia", code: "+57", value: "CO", phoneLength: 10 },
  { label: "Comoros", code: "+269", value: "KM", phoneLength: 7 },
  { label: "Congo", code: "+242", value: "CG", phoneLength: 9 },
  { label: "Costa Rica", code: "+506", value: "CR", phoneLength: 8 },
  { label: "Croatia", code: "+385", value: "HR", phoneLength: 9 },
  { label: "Cuba", code: "+53", value: "CU", phoneLength: 8 },
  { label: "Cyprus", code: "+357", value: "CY", phoneLength: 8 },
  { label: "Czech Republic", code: "+420", value: "CZ", phoneLength: 9 },

  { label: "Denmark", code: "+45", value: "DK", phoneLength: 8 },
  { label: "Djibouti", code: "+253", value: "DJ", phoneLength: 6 },
  { label: "Dominica", code: "+1-767", value: "DM", phoneLength: 7 },
  { label: "Dominican Republic", code: "+1-809", value: "DO", phoneLength: 7 },

  { label: "Ecuador", code: "+593", value: "EC", phoneLength: 9 },
  { label: "Egypt", code: "+20", value: "EG", phoneLength: 10 },
  { label: "El Salvador", code: "+503", value: "SV", phoneLength: 8 },
  { label: "Estonia", code: "+372", value: "EE", phoneLength: 7 },
  { label: "Ethiopia", code: "+251", value: "ET", phoneLength: 9 },

  { label: "Finland", code: "+358", value: "FI", phoneLength: 9 },
  { label: "France", code: "+33", value: "FR", phoneLength: 9 },

  { label: "Georgia", code: "+995", value: "GE", phoneLength: 9 },
  { label: "Germany", code: "+49", value: "DE", phoneLength: 11 },
  { label: "Ghana", code: "+233", value: "GH", phoneLength: 9 },
  { label: "Greece", code: "+30", value: "GR", phoneLength: 10 },

  { label: "Hong Kong", code: "+852", value: "HK", phoneLength: 8 },
  { label: "Hungary", code: "+36", value: "HU", phoneLength: 9 },

  { label: "Iceland", code: "+354", value: "IS", phoneLength: 7 },
  { label: "India", code: "+91", value: "IN", phoneLength: 10 },
  { label: "Indonesia", code: "+62", value: "ID", phoneLength: 11 },
  { label: "Iran", code: "+98", value: "IR", phoneLength: 10 },
  { label: "Iraq", code: "+964", value: "IQ", phoneLength: 10 },
  { label: "Ireland", code: "+353", value: "IE", phoneLength: 9 },
  { label: "Israel", code: "+972", value: "IL", phoneLength: 9 },
  { label: "Italy", code: "+39", value: "IT", phoneLength: 10 },

  { label: "Japan", code: "+81", value: "JP", phoneLength: 10 },
  { label: "Jordan", code: "+962", value: "JO", phoneLength: 9 },

  { label: "Kenya", code: "+254", value: "KE", phoneLength: 9 },
  { label: "Kuwait", code: "+965", value: "KW", phoneLength: 8 },

  { label: "Latvia", code: "+371", value: "LV", phoneLength: 8 },
  { label: "Lebanon", code: "+961", value: "LB", phoneLength: 8 },
  { label: "Lithuania", code: "+370", value: "LT", phoneLength: 8 },
  { label: "Luxembourg", code: "+352", value: "LU", phoneLength: 9 },

  { label: "Malaysia", code: "+60", value: "MY", phoneLength: 9 },
  { label: "Maldives", code: "+960", value: "MV", phoneLength: 7 },
  { label: "Mexico", code: "+52", value: "MX", phoneLength: 10 },
  { label: "Morocco", code: "+212", value: "MA", phoneLength: 9 },

  { label: "Nepal", code: "+977", value: "NP", phoneLength: 10 },
  { label: "Netherlands", code: "+31", value: "NL", phoneLength: 9 },
  { label: "New Zealand", code: "+64", value: "NZ", phoneLength: 9 },
  { label: "Nigeria", code: "+234", value: "NG", phoneLength: 10 },
  { label: "Norway", code: "+47", value: "NO", phoneLength: 8 },

  { label: "Oman", code: "+968", value: "OM", phoneLength: 8 },

  { label: "Pakistan", code: "+92", value: "PK", phoneLength: 10 },
  { label: "Philippines", code: "+63", value: "PH", phoneLength: 10 },
  { label: "Poland", code: "+48", value: "PL", phoneLength: 9 },
  { label: "Portugal", code: "+351", value: "PT", phoneLength: 9 },

  { label: "Qatar", code: "+974", value: "QA", phoneLength: 8 },

  { label: "Romania", code: "+40", value: "RO", phoneLength: 10 },
  { label: "Russia", code: "+7", value: "RU", phoneLength: 10 },

  { label: "Saudi Arabia", code: "+966", value: "SA", phoneLength: 9 },
  { label: "Singapore", code: "+65", value: "SG", phoneLength: 8 },
  { label: "South Africa", code: "+27", value: "ZA", phoneLength: 9 },
  { label: "South Korea", code: "+82", value: "KR", phoneLength: 10 },
  { label: "Spain", code: "+34", value: "ES", phoneLength: 9 },
  { label: "Sri Lanka", code: "+94", value: "LK", phoneLength: 9 },
  { label: "Sweden", code: "+46", value: "SE", phoneLength: 10 },
  { label: "Switzerland", code: "+41", value: "CH", phoneLength: 9 },

  { label: "Thailand", code: "+66", value: "TH", phoneLength: 9 },
  { label: "Turkey", code: "+90", value: "TR", phoneLength: 10 },

  { label: "Ukraine", code: "+380", value: "UA", phoneLength: 9 },
  { label: "United Arab Emirates", code: "+971", value: "AE", phoneLength: 9 },
  { label: "United Kingdom", code: "+44", value: "GB", phoneLength: 10 },
  { label: "United States", code: "+1", value: "US", phoneLength: 10 },

  { label: "Vietnam", code: "+84", value: "VN", phoneLength: 9 },

  { label: "Yemen", code: "+967", value: "YE", phoneLength: 9 },
  { label: "Zimbabwe", code: "+263", value: "ZW", phoneLength: 9 },
];
